export const AccountIdType = {
    GhostAccountId: '-1' //Synthetic root node ID/Tenant used to attatch hierarchy assignments to when Manager doesnt have access to the real tenant
}